import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Control, actions } from 'react-redux-form';
import { Row, Col, Popover } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import {
    ORFButton
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_TextArea as TextArea
} from '../../../../common/forms/order-request-form.component';
import { wirelessAccessoryActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-accessory.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import Translation from "../../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import TableWithButton from '../../../../common/details-table/table-with-button.component';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { BUSINESS_CASE, MODAL_TITLE, ORDER_MSG, OPTION_LABEL, MAX_LENGTH, CIRCUIT_STATUS, SUBMIT_REQUEST_TITLE } from '../../../../../constants/external-constants';
import CustomSearchableSelectWrapper from '../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { Loading } from '../../../../common/loading/index';
import { assignDefaultIfEmptyString } from './../../../../../utils/helpers.utils';
import CustomSearchableDropdownWrapper from '../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';

class AccessoryForm extends Component {
    constructor(props) {
        super(props);
        this.getAccessoryDetailsModel = this.getAccessoryDetailsModel.bind(this);
        this.fetchAddressOptions = this.fetchAddressOptions.bind(this);
        this.state = {
            showConModal: false,
            isSaving: false,
            title: "",
            checkboxValue: true,
            selectedEquipment: [],
            totalCost: 0,
            defaultCheckBoxValue: false,
            selectedCountry: "",
            selectedAddress: "",
            datatable: [
                {
                    "HeaderItem": [],
                    "dataItem": []
                }
            ],
            originalcircuitId: 0,
            originalcircuitCode: '',
            originalcountryCode: '',
            originalbillingLocationAddressId: 0,
            originalbusinessCaseId: 0,
            originalbusinessJustification: '',
            originaladditionalInformation: '',
            originalselectedEquipmentInventortyId: [],
            selectedEquipmentInventoryId: [],
            error: false,
        }
    }

    async componentDidMount() {
        const { isUpdateRequest, takeActionCircuitCode, takeActionCircuitId } = this.props.createRequest;
        const { requestDetail, fetchSubscriptionByRequestDetail, onLoadUpdateAccessoryRequest, setLoadForm, fetchSubscriptionByValue, onSubscriptionSelect } = this.props;

        this.props.getAccessoryFormData();

        if (takeActionCircuitId != null || takeActionCircuitId !== undefined || takeActionCircuitCode) {
            var circuitCodePropName = 'CircuitCode';
            var subscriptionList = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

            onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, subscriptionList, null, takeActionCircuitId);
        }
        else {
            onSubscriptionSelect('');
        }

        if (isUpdateRequest) {
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;
            var circuitCodePropName = 'CircuitCode';
            setLoadForm(true);
            var subscriptionList = await fetchSubscriptionByRequestDetail(currentCircuitCode, circuitCodePropName);

            await onLoadUpdateAccessoryRequest(subscriptionList, circuitCodePropName);
            const { deviceAccessories } = this.props.wirelessAccessoryRequest;
            var tmpDataItem = deviceAccessories[0].dataItem.length ? deviceAccessories[0].dataItem : [];

            var tmpselectedEquipment = [];
            var tmpselectedEquipmentInventoryId = [];
            var tmptotalCost = 0;

            for (let i = 0; i < tmpDataItem.length; i++) {
                for (let k = 0; k < requestDetail.requestData.Subscription.Accessories.length; k++) {
                    if (tmpDataItem[i].EquipmentInventoryId == requestDetail.requestData.Subscription.Accessories[k].EquipmentInventoryId) {
                        tmpselectedEquipment.push(i);
                        tmpselectedEquipmentInventoryId.push(tmpDataItem[i].EquipmentInventoryId);
                        tmptotalCost = tmptotalCost + tmpDataItem[i].OrderCost;
                    }
                }
            }

            var dataTable = {
                datatable: [
                    {
                        "HeaderItem": [...deviceAccessories[0].HeaderItem],
                        "dataItem": [...tmpDataItem],
                    }
                ],
                selectedEquipment: tmpDataItem.length === 1 ? [0] : tmpselectedEquipment,
                originalselectedEquipmentInventortyId: tmpDataItem.length === 1 ? [0] : tmpselectedEquipmentInventoryId,
                selectedEquipmentInventoryId: tmpDataItem.length === 1 ? [0] : tmpselectedEquipmentInventoryId,
                totalCost: tmpDataItem.length === 1 ? parseFloat(tmpDataItem[0].OrderCost) : tmptotalCost,
                defaultCheckBoxValue: tmpDataItem.length === 1
            }
            this.setState({ ...dataTable });

            setLoadForm(false);
        }   
    }

    componentWillUnmount() {
        this.props.resetWirelessAccessoryForm();
        this.props.resetRequestData();
    }

    componentDidUpdate(prevProps) {
        if (this.state.originalcircuitId == 0 &&
            this.props.wirelessAccessoryForm.circuitId !== prevProps.wirelessAccessoryForm.circuitId) {
            this.setState({
                originalcircuitId: this.props.wirelessAccessoryForm.circuitId
            });

        }
        if (this.state.originalcircuitCode == '' &&
            this.props.wirelessAccessoryForm.circuitCode !== prevProps.wirelessAccessoryForm.circuitCode) {
            this.setState({
                originalcircuitCode: this.props.wirelessAccessoryForm.circuitCode
            });

        }
        if (this.state.originalcountryCode == '' &&
            this.props.wirelessAccessoryForm.countryCode !== prevProps.wirelessAccessoryForm.countryCode) {
            this.setState({
                originalcountryCode: this.props.wirelessAccessoryForm.countryCode
            });

        }
        if (this.state.originalbillingLocationAddressId == '' &&
            this.props.wirelessAccessoryForm.billingLocationAddressId !== prevProps.wirelessAccessoryForm.billingLocationAddressId) {
            this.setState({
                originalbillingLocationAddressId: this.props.wirelessAccessoryForm.billingLocationAddressId
            });

        }
        if (this.state.originalbusinessCaseId == '' &&
            this.props.wirelessAccessoryForm.businessCaseId !== prevProps.wirelessAccessoryForm.businessCaseId) {
            this.setState({
                originalbusinessCaseId: this.props.wirelessAccessoryForm.businessCaseId
            });

        }
        if (this.state.originalbusinessJustification == '' &&
            this.props.wirelessAccessoryForm.businessJustification !== prevProps.wirelessAccessoryForm.businessJustification) {
            this.setState({
                originalbusinessJustification: this.props.wirelessAccessoryForm.businessJustification
            });

        }
        if (this.state.originaladditionalInformation == '' &&
            this.props.wirelessAccessoryForm.additionalInformation !== prevProps.wirelessAccessoryForm.additionalInformation) {
            this.setState({
                originaladditionalInformation: this.props.wirelessAccessoryForm.additionalInformation
            });

        }
    }

    submitRequest = () => {
        this.setState({showConModal:true})
    }

    getAccessoryDetailsModel() {
        var accessoryDetailsModel = [];
        const dataItem = this.state.datatable[0].dataItem;
        this.state.selectedEquipment.map(i => accessoryDetailsModel.push(dataItem[i]));
        return accessoryDetailsModel;
    }

    handleConfirmationModal = async (buttonType) => {
      
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { submitRequest, fetchRequestLogItems, setAccessoryDetailsModel } = this.props;

            setAccessoryDetailsModel(this.getAccessoryDetailsModel());
            this.setState({
                isSaving: true,
            });
            var success = await submitRequest();
            let resultMessage = success.Message;
            if (success.Success) {
                fetchRequestLogItems(0);
                this.setState({
                    title: "Success"
                });
                this.props.hideRequestModal();
                const { isUpdateRequest } = this.props.createRequest;
                resultMessage = isUpdateRequest ? this.toLocaleLanguage("order_has_been_updated") : this.toLocaleLanguage("order_has_been_submitted");
            }else {
                this.setState({
                    title: "Error"
                });
                resultMessage = success.Message ? success.Message : this.toLocaleLanguage("order_save_error_message");
            }
            this.setState( prev => ({
                showConModal: !prev.showConModal,
                show: true,
                isSaving: false,
                message: resultMessage,
                })
            )
        } else {
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false });   
        if(this.state.title!=="Error")
        {
            this.props.history.goBack();
        } 
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    renderPopover = (title, body) => {
        return (
            <Popover id="comp-popover" title={title} className="plan-comp-popover">
                {body}
            </Popover>
        );
    };

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    getCheckboxValue = (isChecked, value) => {
        const { deviceAccessories } = this.props.wirelessAccessoryRequest;
        const selectedEquipment = !isChecked
            ? this.state.selectedEquipment.filter(e => e !== value)
            : this.state.selectedEquipment.indexOf(value) > -1
                ? [...this.state.selectedEquipment]
                : [...this.state.selectedEquipment, value];
        const dataItem = this.state.datatable[0].dataItem;
        var totalCost = 0;
        var selectedEquipmentInventoryId = [];
        selectedEquipment.map(s => totalCost += parseFloat(deviceAccessories[0].dataItem[s].OrderCost));
        selectedEquipment.map(i => selectedEquipmentInventoryId.push(dataItem[i].EquipmentInventoryId));
        
        this.setState({
            selectedEquipment: selectedEquipment,
            selectedEquipmentInventoryId: selectedEquipmentInventoryId,
            totalCost: totalCost
        });
    }
    renderSubscriptionDetails = () => {
        const {isUpdateRequest, subscriptionList } = this.props.createRequest;
        const {subscription} = this.props.wirelessAccessoryRequest;
        const circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";
        const statusClassName = circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended";
    
        const vendorName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].VendorName : subscription.VendorName;
        const planName =  subscription?.PlanName || <Translation translationKey="no_plan_available" />;
        const deviceName = subscription?.DeviceName || <Translation translationKey="no_device_available" />;
        
        return (
            <div className="pb-15-pl-30">
            <span className={statusClassName}>{circuitStatusName} </span> <span>| </span>
            {vendorName} <span>| </span>
            {planName} <span>| </span>
            {deviceName}
            </div>
        );
    };

    async handleChangeSubscription(value, propsName, objects, index) {
        await this.props.onSubscriptionSelect(value, propsName, objects, index);
        const { deviceAccessories } = this.props.wirelessAccessoryRequest;
        var tmpDataItem = deviceAccessories[0]?.dataItem?.length ? deviceAccessories[0].dataItem : [];
        var dataTable = {
            datatable: [
                {
                    "HeaderItem": [...(deviceAccessories[0]?.HeaderItem ?? [])],
                    "dataItem": [...tmpDataItem],
                }
            ],
            selectedEquipment: tmpDataItem.length === 1 ? [0] : [],
            totalCost: tmpDataItem.length === 1 ? parseFloat(tmpDataItem[0].OrderCost) : 0,
            defaultCheckBoxValue: tmpDataItem.length === 1
        }
        this.setState({ ...dataTable });
    }

    async fetchAddressOptions() {
        const { wirelessAccessoryForm, onCountrySelect } = this.props;
        const { selectedCountry, selectedAddress } = this.state;
        
        if (wirelessAccessoryForm.countryCode?.trim() !== ""
            && (wirelessAccessoryForm.countryCode !== selectedCountry || selectedAddress !== wirelessAccessoryForm.billingLocationAddressId)){
            await onCountrySelect("wirelessAccessoryForm.countryCode", wirelessAccessoryForm.countryCode);
            this.setState({
                selectedCountry: wirelessAccessoryForm.countryCode,
                selectedAddress: wirelessAccessoryForm.billingLocationAddressId
            });
            return this.props.wirelessAccessoryRequest.addressOptions;
        }

        return [];
    }

    render() {
        const { subscriptionList, takeActionCircuitCode, isUpdateRequest, isRequestOnBehalf, requestOnBehalfData } = this.props.createRequest;
        const { wirelessAccessoryForm, setRequestorAddress, fetchSubscriptionByValue, onBusinessCaseSelect, onAddressSelect, requestDetail, onCountrySelect } = this.props;
        const { countryOptions
            , addressOptions
            , businessCaseOptions
            , formSubmitted
            , subscription
            , isFormLoading
            , isResetLoading

            , isCountryLoading
            , hasMoreCountry
            , isAddressLoading
            , hasMoreAddress } = this.props.wirelessAccessoryRequest;
        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";
        let showPreferredAddress = wirelessAccessoryForm.billingLocationAddressId.toString() === "-1";
        let disable = wirelessAccessoryForm.countryCode == ''
            || wirelessAccessoryForm.billingLocationAddressId === '';

        if (showPreferredAddress) {
            disable = disable || wirelessAccessoryForm.otherLocationAddress === '';
        }

        const initialRequired = wirelessAccessoryForm.circuitId == 0
            || wirelessAccessoryForm.countryCode == ''
            || wirelessAccessoryForm.billingLocationAddressId == 0
            || wirelessAccessoryForm.deliveryAddress == ''
            || (wirelessAccessoryForm.billingLocationAddressId == -1 && wirelessAccessoryForm.otherLocationAddress == '' ? true : false)
            || wirelessAccessoryForm.businessCaseId == 0
            || wirelessAccessoryForm.businessJustification == ''
            || this.state.selectedEquipment.length === 0
            || (isRequestOnBehalf && !(requestOnBehalfData && requestOnBehalfData.EmployeeId > 0))
            || formSubmitted

        if (isUpdateRequest) {

            const originalselectedEquipmentInventortyId = this.state.originalselectedEquipmentInventortyId.slice().sort();
            const selectedEquipmentInventoryId = this.state.selectedEquipmentInventoryId.slice().sort();

            const IsUpdatedSelectedEquipment = ((JSON.stringify(originalselectedEquipmentInventortyId) == JSON.stringify(selectedEquipmentInventoryId)) ? false : true)

            var updateRequired = isUpdateRequest && !(requestDetail.requestData.Circuit.CircuitCode != wirelessAccessoryForm.circuitCode
                || requestDetail.requestData.BillingAddress.CountryCode != wirelessAccessoryForm.countryCode
                || requestDetail.requestData.BillingAddress.LocationId != wirelessAccessoryForm.billingLocationAddressId
                || requestDetail.requestData.BillingAddress.OtherDeliveryAddress != assignDefaultIfEmptyString(wirelessAccessoryForm.otherLocationAddress, null)
                || requestDetail.requestData.BusinessJustification.BusJustiCodeDetailId != wirelessAccessoryForm.businessCaseId
                || requestDetail.requestData.BusinessJustification.BusinessJustification != wirelessAccessoryForm.businessJustification
                || requestDetail.requestData.BusinessJustification.AdditionalInformation != assignDefaultIfEmptyString(wirelessAccessoryForm.additionalInformation, null)
                || IsUpdatedSelectedEquipment);
        }

        return isFormLoading ?
            (<div>
                <Loading />
            </div>) : (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
                 <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")}
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest : this.toLocaleLanguage("submit_form_request_title")}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                    disabled={this.state.isSaving}
                />
                <Form method="post" role="form"
                    model="wirelessAccessoryForm"
                    onSubmit={this.submitRequest}
                >
                    <Row className='mh-70'>
                        <Col className='required' xs={12} md={12} lg={12}>
                        {
                           !isResetLoading && <SearchSuggestions
                                value={wirelessAccessoryForm.circuitCode}
                                label={`${this.toLocaleLanguage('mobile_phone_number')}`}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={this.handleChangeSubscription.bind(this)}
                                searchAction={fetchSubscriptionByValue}
                                defaultValue={takeActionCircuitCode}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                errorMessage={this.toLocaleLanguage('error_mobile_number_not_exist')}
                                haveError={this.haveError}
                            />
                         }
                        </Col>
                        {
                        wirelessAccessoryForm.circuitCode !== '' &&
                            this.renderSubscriptionDetails()
                        }
                    </Row>                   
                    {wirelessAccessoryForm.circuitCode !== '' && <div className="price-plan-right-details mt-4">
                        
                        <div className="price-plan-header required">
                            <span className='label'><Translation translationKey="select_accessory"/></span>                            
                        </div>                        
                    </div>}
                    {wirelessAccessoryForm.circuitCode !== '' && <TableWithButton
                            classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub"
                            datatable={this.state.datatable}
                            haveExternalDeleteBtn={false}
                            haveCheckBox={true}
                            enableCheckBox={true}
                            getCheckboxValue={this.getCheckboxValue}
                            defaultCheckBoxValue={this.state.defaultCheckBoxValue}
                            currencyName={subscription.CurrencyName}
                            defaultSelected={this.state.selectedEquipment}
                    />}
                    {wirelessAccessoryForm.circuitCode !== '' && <div className="price-plan-total-cost-container mb-2">
                        <div className="price-plan-header">
                            <span><Translation translationKey="total_order_cost" /></span>
                        </div>
                        <div className="price-plan-total">
                            <span>{subscription.CurrencyName}</span>

                            <span>{parseFloat(this.state.totalCost).toFixed(2)}</span>
                        </div>
                    </div>}
                    <Row>
                        <div className='use-request-container'>
                            <span onClick={setRequestorAddress} className="requestor-address-link">Use Requestor Address</span>
                        </div>
                        <Col className='required custom-wrapper-plan custom-margin' xs={12} md={12} lg={12}>
                            <CustomSearchableDropdownWrapper
                                label={this.toLocaleLanguage('country')}
                                options={countryOptions}
                                selected={wirelessAccessoryForm.countryCode}
                                onChange={(e) => onCountrySelect('wirelessAccessoryForm.countryCode', e)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.countryCode'
                                tagName='countryCode'
                                optionLabelKey={OPTION_LABEL.KEY_VALUE}
                                maxLength={MAX_LENGTH.limit_100}

                                onSearchChange={this.props.handleCountrySearch}
                                onLoadMore={(e) => this.props.loadMoreCountry(e)}
                                isLoading={isCountryLoading}
                                hasMore={hasMoreCountry}
                            />
                        </Col>
                    </Row>
                    <Row>                       
                        <Col className={`requesto-info-container required mb-0 ${(wirelessAccessoryForm.deliveryAddress === ''  || disable) ? "mb-4" : ""}`} xs={12} md={12} lg={12}>
                            <CustomSearchableDropdownWrapper
                                className="form-control"
                                label={this.toLocaleLanguage('delivery_address')}
                                options={addressOptions}
                                selected={wirelessAccessoryForm.billingLocationAddressId}
                                onChange={(e) => onAddressSelect('wirelessAccessoryForm.billingLocationAddressId', e)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.billingLocationAddressId'
                                tagName='billingLocationAddressId'   
                                optionLabelKey={OPTION_LABEL.KEY_VALUE}
                                maxLength={MAX_LENGTH.limit_500}
                                   
                                onSearchChange={this.props.handleAddressSearch}
                                onLoadMore={this.props.loadMoreAddress}
                                isLoading={isAddressLoading}
                                hasMore={hasMoreAddress}
                            />
                             {      
                                wirelessAccessoryForm.deliveryAddress != '' && !disable &&
                                <div className={`delivery-address-label mb-3`}>
                                    {wirelessAccessoryForm.deliveryAddress}
                                </div>
                            }
                        </Col>
                    </Row>                   
                    {showPreferredAddress &&
                        <Row>
                            <Col className='required' xs={12} md={12} lg={12}>
                                <TextArea label={`${this.toLocaleLanguage('preferred_delivery_address')}`}
                                    fieldProp='.otherLocationAddress'
                                    value={wirelessAccessoryForm.otherLocationAddress}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.limit_255}
                                />

                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col className='required' xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('business_case')}`}
                                value={wirelessAccessoryForm.businessCaseId}
                                options={businessCaseOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.businessCaseId'
                                onChangeAction={onBusinessCaseSelect}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='required' xs={12} md={12} lg={12}>
                            <TextArea label={`${this.toLocaleLanguage('business_justification')}`}
                                fieldProp='.businessJustification'
                                value={wirelessAccessoryForm.businessJustification}
                                disabled={parseInt(wirelessAccessoryForm.businessCaseId) !== BUSINESS_CASE.other}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_500}
                            />
                        </Col>  
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelessAccessoryForm.additionalInformation}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_1000}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={isUpdateRequest ? (initialRequired || updateRequired) : initialRequired}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter (connect(
    state => {
        const { createRequest, wirelessAccessoryRequest, translation, requestDetail } = state;
        const { wirelessAccessoryForm } = state.form;
        return {
            wirelessAccessoryForm
            , createRequest
            , wirelessAccessoryRequest
            , ...translation
            , requestDetail
        };
    }
    , dispatch => ({
        ...bindActionCreators(
            Object.assign({}, wirelessAccessoryActions
                , createRequestActions
                , requestLogActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(AccessoryForm));